/**
 * Map & Terrain System Types (Shared)
 *
 * Canonical type definitions for map configuration and terrain,
 * shared across backend, frontend, and mobile.
 */
/**
 * Type guard to distinguish EnemyPlacement[] from SpawnZone (HexCoordinate[])
 * in the enemySpawn union. Both are arrays, so we check the first element's shape.
 * An empty array is treated as an empty SpawnZone (no enemy positions).
 */
export function isEnemyPlacementArray(spawn) {
    const first = spawn[0];
    return first !== undefined && 'creatureIndex' in first;
}
/**
 * Generate a SpawnZone from column/row cross-product.
 * Utility for converting old rectangular zone definitions.
 */
export function generateSpawnHexes(columns, rows) {
    const hexes = [];
    for (const q of columns) {
        for (const r of rows) {
            hexes.push({ q, r });
        }
    }
    return hexes;
}
//# sourceMappingURL=map.js.map